import React from "react";
import "../styles/Hero.css";

import { SiGithub, SiLinkedin, SiGmail } from "react-icons/si";

function Hero() {
  return (
    <div className="hero" id="hero">
      <div className="side-left">
        <img src="/assets/diyah.png" alt="hero" />
      </div>
      <div className="side-right">
        <h3>Hi, I am</h3>
        <h1>
          Chalimatus Sa'<span>diyah</span>
        </h1>
        <h2>Frontend Developer</h2>
        <div className="hero-icon">
          <a
            href="https://github.com/diydiyydiyyy"
            target="_blank"
            rel="noreferrer"
          >
            <SiGithub />
          </a>

          <a
            href="mailto:chalimatus.sadiyah.098@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <SiGmail />
          </a>

          <a
            href="https://www.linkedin.com/in/chalimatussadiyah/"
            target="_blank"
            rel="noreferrer"
          >
            <SiLinkedin />
          </a>
        </div>
        <a
          href="https://drive.google.com/file/d/1U9N4PAcmQfYagYfPh_e31GkyRq1t_g5H/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          <button>Download CV</button>
        </a>
      </div>
    </div>
  );
}

export default Hero;
